import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface IPaper {
    width?: string;
    height?: string;
    backgroundColor?: string;
    borderRadius?: string;
    children?: ReactNode;
    onClick?: (e: any) => void;
    name?: string;
    testid?: string;
}

export const PaperWrapper = styled.div<Partial<IPaper>>`
    width: ${(props: any) => props.width};
    height: ${(props: any) => props.height};
    background-color: ${(props: any) => props.backgroundColor};
    border-radius: ${(props: any) => props.borderRadius};
    box-shadow: 0px 0px 1px rgba(52, 58, 63, 0.1), 0px 1px 5px rgba(52, 58, 63, 0.1);
    padding: 24px;
    cursor: pointer;
`;

export const Paper = ({
    width = '100px',
    height = '100px',
    backgroundColor = 'white',
    borderRadius = '8px',
    onClick,
    name = 'Paper',
    testid = '',
    children,
}: IPaper) => {
    return (
        <PaperWrapper
            width={width}
            height={height}
            backgroundColor={backgroundColor}
            borderRadius={borderRadius}
            onClick={onClick}
            name={name}
            key={name}
            data-testid={testid}
        >
            {children}
        </PaperWrapper>
    );
};
